import { FaLinkedinIn, FaFacebookF, FaInstagram} from 'react-icons/fa';


const Content =[
    // {
    //     id:1,
    //     Designation:"Fresher-Software Developer",
    //     Exp:"0-1 year",
    //     Location:"Noida",
    //     jobtype:"Full Time",
    //     socialmedia:[
    //         {
    //             path:"/careers",
    //             icon:<FaLinkedinIn/>,
    //         },
    //         {
    //             path:"/careers",
    //             icon:<FaFacebookF/>,
    //         },
    //         {
    //             path:"/careers",
    //             icon:<FaInstagram/>,
    //         },
    //     ],
       
        
    // },
    {
        id:2,
        Designation:"Software Developer",
        Exp:"0-1 year",
        Location:"Delhi",
        jobtype:"Full Time",
        socialmedia:[
            {
                path:"/careers",
                icon:<FaLinkedinIn/>,
            },
            {
                path:"/careers",
                icon:<FaFacebookF/>,
            },
            {
                path:"/careers",
                icon:<FaInstagram/>,
            },
        ],
       
        
    },
    {
        id:3,
        Designation:"Tally",
        Exp:"0-1 year",
        Location:"Noida",
        jobtype:"Full Time",
        socialmedia:[
            {
                path:"/careers",
                icon:<FaLinkedinIn/>,
            },
            {
                path:"/careers",
                icon:<FaFacebookF/>,
            },
            {
                path:"/careers",
                icon:<FaInstagram/>,
            },
        ],
       
        
    },
    // {
    //     id:4,
    //     Designation:"BDE",
    //     Exp:"0-1 year",
    //     Location:"Delhi",
    //     jobtype:"",
    //     socialmedia:[
    //         {
    //             path:"/careers",
    //             icon:<FaLinkedinIn/>,
    //         },
    //         {
    //             path:"/careers",
    //             icon:<FaFacebookF/>,
    //         },
    //         {
    //             path:"/careers",
    //             icon:<FaInstagram/>,
    //         },
    //     ],
       
        
    // },
    // {
    //     id:5,
    //     Designation:"Tally Developer",
    //     Exp:"0-1 year",
    //     Location:"Noida",
    //     jobtype:"Part Time",
    //     socialmedia:[
    //         {
    //             path:"/careers",
    //             icon:<FaLinkedinIn/>,
    //         },
    //         {
    //             path:"/careers",
    //             icon:<FaFacebookF/>,
    //         },
    //         {
    //             path:"/careers",
    //             icon:<FaInstagram/>,
    //         },
    //     ],
       
        
    // },
    // {
    //     id:6,
    //     Designation:"Fresher-Software Developer",
    //     Exp:"0-1 year",
    //     Location:"Noida",
    //     jobtype:"Full Time",
    //     socialmedia:[
    //         {
    //             path:"/careers",
    //             icon:<FaLinkedinIn/>,
    //         },
    //         {
    //             path:"/careers",
    //             icon:<FaFacebookF/>,
    //         },
    //         {
    //             path:"/careers",
    //             icon:<FaInstagram/>,
    //         },
    //     ],
       
        
    // },
    // {
    //     id:7,
    //     Designation:"Fresher-Software Developer",
    //     Exp:"0-1 year",
    //     Location:"Noida",
    //     jobtype:"Full Time",
    //     socialmedia:[
    //         {
    //             path:"/careers",
    //             icon:<FaLinkedinIn/>,
    //         },
    //         {
    //             path:"/careers",
    //             icon:<FaFacebookF/>,
    //         },
    //         {
    //             path:"/careers",
    //             icon:<FaInstagram/>,
    //         },
    //     ],
       
        
    // },
    
   
  
];
export default Content;